import { interviewTime } from '@stores/atoms/time';
import { useAtomValue } from 'jotai';
import { Container, TimerIcon } from './style';

const Time = () => {
  const totalInterviewTime = useAtomValue(interviewTime);
  return <>{`면접 진행 시간 ${totalInterviewTime}`}</>;
};

const InterviewTime = () => {
  return (
    <Container>
      <TimerIcon />
      <Time />
    </Container>
  );
};

export default InterviewTime;
